import { FORBIDDEN_EXACT, FORBIDDEN_PARTIAL } from 'utils/usernameForbidden';

const exactPart = FORBIDDEN_EXACT.map(w => `^${w}$`).join('|');
const partialPart = FORBIDDEN_PARTIAL.join('|');
const regex = new RegExp(`${exactPart}|${partialPart}`, 'i');

export default regex;
